"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldTriggerButton = shouldTriggerButton;

var _keyCodes = require("./keyCodes");

/**
Returns true if the passed keyCode should trigger/select/click a button: space bar or enter. Used for selecting or "clicking" things.
@function shouldTriggerButton
@param {number} keyCode
@return {bool}
**/
function shouldTriggerButton(keyCode) {
  return keyCode === _keyCodes.ENTER_KEY || keyCode === _keyCodes.SPACEBAR_KEY;
}


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/util/accessibility.js
// module id = 356
// module chunks = 0